import { Controller } from '@hotwired/stimulus'

// Keeps one sidebar <details> group open at a time (accordion behavior).
export default class extends Controller {
  static targets = ['section']

  toggle (event) {
    const opened = event.currentTarget
    if (!opened.open) return

    this.sectionTargets.forEach((section) => {
      if (section !== opened) section.removeAttribute('open')
    })
  }
}
